// extracted by css-extract-rspack-plugin
export default {"root":"chBh7","iframe":"UkML6","hidden":"mqeQ0"};